import axios from "../../axios";

const api = {
  createLocation({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/locations`, data, headers)
      .then(({ data }) => data);
  },

  updateLocation({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/locations/${id}`, data, headers)
      .then(({ data }) => data);
  }
};

export default api;